import { render, staticRenderFns } from "./NumberView.vue?vue&type=template&id=de84a606"
import script from "./NumberView.vue?vue&type=script&lang=js"
export * from "./NumberView.vue?vue&type=script&lang=js"
import style0 from "./NumberView.vue?vue&type=style&index=0&id=de84a606&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports